import React, { useState } from "react"
import { Steps } from "../journey/step-library"
import { H2, Container, FlexContainer } from "@carrotfertility/carotene"
import ArrowSubmitButton from "components/carrot-plans/shared/ArrowSubmitButton"
import { useMedicalInfo } from "../../context/MedicalInfoContext"
import { Skip } from "../../../views/fle/Molecules"
import { useStateMachine } from "../../../context/stateMachine/StateMachineContext"
import { FormInputWithUnit } from "../../../views/atoms/forms/FormInputWithUnit"
import { useJourneyFlow } from "../../shared/JourneyFlowContainer"
import { Label } from "../../../views/atoms/Atoms"

const step = Steps.HEIGHT_WEIGHT
export default function HeightWeightStep(): JSX.Element {
  const title = "Please enter your height & weight."
  const { medicalInfo, updateMedicalInfo, hasQuestionBeenSkipped } = useMedicalInfo()
  const { handleContinueLoading, continueLoading } = useJourneyFlow()

  const [weight, setWeight] = useState(medicalInfo?.weight)
  const [height] = useState(medicalInfo?.height)
  const [heightFt, setHeightFt] = useState(height ? Math.floor(height / 12) : null)
  const [heightIn, setHeightIn] = useState(height ? height % 12 : null)

  const { setNextStep } = useStateMachine(step, height || weight || hasQuestionBeenSkipped(step) ? "" : null)

  async function onClickContinue(): Promise<void> {
    if (!heightFt && !heightIn && !weight) {
      onSkip()
    } else {
      const medicalInfoPayload = {}
      medicalInfoPayload["height"] = heightFt * 12 + heightIn || 0
      medicalInfoPayload["heightUnits"] = "IN"
      medicalInfoPayload["weight"] = weight || 0
      medicalInfoPayload["weightUnits"] = "LB"

      await handleContinueLoading(() => updateMedicalInfo(medicalInfoPayload))
      setNextStep(step, "")
    }
  }

  async function onSkip(): Promise<void> {
    await handleContinueLoading(() => updateMedicalInfo({ skipFields: [step] }))
    setNextStep(step, "")
  }

  return (
    <form
      onSubmit={(event) => {
        event.preventDefault()
        onClickContinue()
      }}
    >
      <Container stack="large">
        <H2 stack="tiny">{title}</H2>
      </Container>
      <Container>
        <div className="flex justify-between-ns flex-wrap items-end nh25 mb2">
          <div className="w-50 flex-grow-1 ph25 min-w250px mb2">
            <Label valid={true} htmlFor="heightFtInput">
              Height
            </Label>
            <FormInputWithUnit
              id={"heightFtInput"}
              name="height"
              unit={"ft"}
              type={"number"}
              min={"1"}
              max={"10"}
              onChange={(e) => {
                setHeightFt(parseInt(e.target.value))
              }}
              required={!!heightIn}
              value={heightFt}
              step={1}
              disabled={continueLoading}
            />
          </div>
          <div className="w-50 flex-grow-1 ph25 min-w250px mb2">
            <FormInputWithUnit
              id={"heightInInput"}
              name="height"
              unit={"in"}
              type={"number"}
              min={"0"}
              max={"11"}
              onChange={(e) => {
                setHeightIn(parseInt(e.target.value))
              }}
              required={!!heightFt}
              value={heightIn}
              step={1}
              disabled={continueLoading}
            />
          </div>
        </div>
        <div className={"flex items-end pt2"}>
          <div className={"fl w-100"}>
            <Label valid={true} htmlFor="weightInput">
              Weight
            </Label>
            <FormInputWithUnit
              id={"weightInput"}
              name="weight"
              unit={"lbs"}
              type={"number"}
              min={"0"}
              max={"999"}
              onChange={(e) => setWeight(e.target.value)}
              value={weight}
              step={0.1}
              disabled={continueLoading}
            />
          </div>
        </div>
      </Container>
      <FlexContainer paddingTopBottom="huge" justifyContent="space-between">
        <Skip onClick={onSkip} onClickOnly enabled={!continueLoading} />
        <ArrowSubmitButton enabled={!continueLoading}>Continue</ArrowSubmitButton>
      </FlexContainer>
    </form>
  )
}
